import React from 'react';

import * as _hm from './_hm';
import * as _ht from './_ht';
import * as _cr from './_cr';

import * as ica from 'src/ica';
import * as icv from 'src/icv';

import { a } from './_cmABT';
import * as l from './_csLcl';

import * as BoxC from './_ccbBoxC';
import * as GridC from './_cccGridC';
import * as SrlC from './_ccbSrlC';
import * as PnnC from './_ccmPnnC';

export type tTblCz = {
  abtz?: _ht.dz, 
  boxStlz: _ht.dz,
  srlCz: SrlC.tSrlCz,
  hdrCz: GridC.tGridCz,
  bdyCz: GridC.tGridCz,
  pnnCz: PnnC.tPnnCz,
};

const $grtAbtz = (pz?: {
  type?: _ht.s,
  bc?: _ht.s,
}) => {
  const _bc = pz?.bc ?? 'lt7';
  switch (pz?.type) {
    case 'line':
      return {
        boxStlz: a(`dw/f`),
        srlCz: {
          abtz: {},
        },
        boxCz: {
          abtz: {},
        },
        hdrCz: {
          abtz: {},
          boxStlz: a(`bc/${_bc} bw/0 bwb/2 dw/f mb/1`),
        },
        bdyCz: {
          abtz: {},
          boxStlz: a(`dw/f`),
        },
        pnnCz: {
          abtz: {},
        }
      }
    default:
      return {
        srlCz: {
          abtz: {},
        },
        boxCz: {
          abtz: {},
        },
        hdrCz: {
          abtz: {},
          boxStlz: {},
        },
        bdyCz: {
          abtz: {},
        },
        pnnCz: {
          abtz: {},
        }
      }
  }
};

export const N = React.memo((pz: tTblCz) => {

  const _sPnnz = l.useDz();

  const _abtz = $grtAbtz(pz.abtz);

  const _rows = pz.bdyCz.lineCs;

  const _ls = [

    _cr.c(GridC.N, {
      key: -10,
      ... _abtz.hdrCz,
      ... pz.hdrCz,
      boxStlz: {
        ... _abtz.hdrCz.boxStlz,
        ... pz.hdrCz.boxStlz,
      },
      lineCs: pz.hdrCz.lineCs,
    }),

    _cr.c(GridC.N, {
      key: -20,
      ... _abtz.bdyCz,
      ... pz.bdyCz,
      boxStlz: {
        ... _abtz.bdyCz.boxStlz,
        ... pz.bdyCz.boxStlz,
      },
//      lineCs: _rows?.filter( ( _dz: _ht.dz, _nIdx: _ht.n ) => _nIdx >= _sPnnz.crt.nCrtIdxStt && _nIdx <= _sPnnz.crt.nCrtIdxEnd),
      lineCs: _rows, // limitter を無効化
      msgCz: {
        ... pz.bdyCz.msgCz,
        text: '該当なし',
        textStlz: a('mb/1'),
      }
    }),

/*
    _cr.c(PnnC.N, {
      key: -30,
      ... _abtz.pnnCz,
      ... pz.pnnCz,
      cz: {
        nTtlCnt: _rows?.length,
//        nCntPerPage: icv.nCntPerPageMax ?? 100,
        nCntPerPage: 100,
        onChg: ( _dz: _ht.dz ) => {
          _sPnnz.set(_dz);
        },
      },
    }),
*/

  ];

  return (
    pz.srlCz ?
      _cr.c(SrlC.N, {
        ... _abtz.srlCz,
        ... pz.srlCz,
        srlClds: _ls,
      })
    :
      _cr.c(BoxC.N, {
        boxStlz: {
          ... _abtz.boxStlz,
          ... pz.boxStlz,
        },
        boxClds: _ls,
      })

  )
});
